export interface CoachingFormData {
  // Step 1 — Basic Info
  full_name: string;
  email: string;
  location: string;
  phone: string;

  // Step 2 — Struggles & Impact
  struggles: string[];
  struggles_other: string;
  adhd_awareness: string;
  life_impact_areas: string[];
  daily_life_description: string;

  // Step 3 — Goals & Readiness
  desired_changes: string[];
  coaching_hope: string;
  readiness: string;
  obstacles: string;
  fit_acknowledgment: boolean;
  seek_support_reason: string;
}

export const EMPTY_FORM_DATA: CoachingFormData = {
  full_name: '',
  email: '',
  location: '',
  phone: '',
  struggles: [],
  struggles_other: '',
  adhd_awareness: '',
  life_impact_areas: [],
  daily_life_description: '',
  desired_changes: [],
  coaching_hope: '',
  readiness: '',
  obstacles: '',
  fit_acknowledgment: false,
  seek_support_reason: '',
};

export const STRUGGLE_OPTIONS = [
  'Overwhelm and task pile-up',
  'Procrastination and getting started',
  'Following through to completion',
  'Mental clutter and racing thoughts',
  'Burnout and exhaustion',
  'Time blindness and being late',
  'Emotional regulation',
  'Organization and clutter',
  'Self-criticism and shame',
  'Other',
];

export const IMPACT_AREA_OPTIONS = [
  'Work or career performance',
  'Home management and chores',
  'Relationships and communication',
  'Self-confidence and self-worth',
  'Health and self-care routines',
  'Financial management',
  'Parenting or family responsibilities',
];

export const CHANGE_OPTIONS = [
  'Build consistent daily routines',
  'Improve focus and productivity',
  'Stop procrastinating and follow through',
  'Feel less overwhelmed and more in control',
  'Better manage emotions and stress',
  'Improve self-confidence and reduce self-criticism',
  'Create more work-life balance',
];

export const ADHD_AWARENESS_OPTIONS = [
  'Less than a year',
  '1–3 years',
  '3–5 years',
  'More than 5 years',
];

export const READINESS_OPTIONS = [
  { value: 'yes', label: 'Yes — I\'m fully ready to do the work' },
  { value: 'somewhat', label: 'Somewhat — I\'m cautiously hopeful' },
  { value: 'unsure', label: 'I\'m not sure yet, still exploring' },
];

export const INTAKE_STEPS = [
  'Basic Info',
  'Your Experience',
  'Goals & Fit',
  'Schedule Call',
  'Review',
];
